import { isWorkEmail } from './is-work-email'

export const generateTeamName = (
  email: string,
  fullName: string,
  suffix: string = 'team',
): string => {
  if (isWorkEmail(email)) {
    const domain = email.split('@')[1]
    const teamName = domain.split('.').slice(0, -1).join('.')
    return teamName.charAt(0).toUpperCase() + teamName.slice(1)
  }

  return `${fullName.split(' ')[0]}’s ${suffix}`
}
